import React, { Component, Fragment } from "react";
import "./Item.css";
import withRouter from "../../withRouter/withRouter";
import Dialog from "../../Dialog/Dialog";
import { toEnglishNumber } from "../../../classes/utils";
const Joi = require("joi");
class Item extends Component {
    itemImageRatio = 0.75;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.categoryFormRef = React.createRef();
        this.colorPickerRef = React.createRef();
        this.newColorName = React.createRef();
        this.fileInputRef = React.createRef();
        this.mediaShowRef = React.createRef();
        this.newSpeceInput = React.createRef();
        this.specesFormRef = React.createRef();
        this.colorsFormRef = React.createRef();
        this.containerRef = React.createRef();
        this.unitSelectRef = React.createRef();

        this.addColor = this.addColor.bind(this);
        this.prepareMedias = this.prepareMedias.bind(this);
        this.revertChanges = this.revertChanges.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.maximizeImage = this.maximizeImage.bind(this);
        this.addSpece = this.addSpece.bind(this);
        this.uploadFiles = this.uploadFiles.bind(this);
    }
    state = {
        speces: {
            عرض: "",
            طول: "",
            "ضخامت/قطر": "",
            "درجه کیفی": "",
            "نوع بافت": "",
            "کیفیت ساخت": "",
            "کشور سازنده": "",
        },
        item: {},

        mediaToShow: {},

        dialog: null,

        showMaximizedImage: false,
        unit: "متر",
    };

    componentDidMount() {
        let { id } = this.props.router.params;
        if (id && id !== "new") {
            this.props.connection
                .get_filtered_data("items", { id })
                .then((res) => {
                    const item = res.data.items[0];
                    item.colors = item?.colors.map((c) => {
                        c.available_amount = parseFloat(
                            c.available_amount || 0
                        );
                        return c;
                    });
                    console.log(item.colors);
                    this.unitSelectRef.current.value = item.unit;
                    this.showMedia(item.medias[0]);
                    this.setState({ item });
                })
                .catch((err) => {
                    if (err.response.status === 404) {
                        this.props.toast("کالا یافت نشد", " danger");
                        this.props.router.navigate("/items/new");
                    }
                });
        }
        this.props.connection
            .getAllCategories()
            .then((res) => {
                this.setState({ categories: res.data });
            })
            .catch((err) => {
                this.props.toast(
                    "خطا در دریافت اطلاعات",
                    "خطا در دریافت اطلاعات دسته بندی ها" + err,
                    " warning"
                );
            });
    }

    addColor() {
        let colorName = this.newColorName.current.value;
        if (colorName == "") {
            this.props.toast("نام رنگ", "نام رنگ را مشخص کنید", " warning");
            return;
        }
        let newColor = {
            color: this.colorPickerRef.current.value,
            name: colorName,
        };
        let { item } = this.state;
        let { colors } = item;
        colors = colors ? colors : [];
        if (
            colors.findIndex((c) => {
                return (
                    c.name === newColor.name || c.color.color === newColor.color
                );
            }) > -1
        ) {
            this.props.toast(
                "رنگ  تکراری",
                "این رنگ قبلا اضافه شده است",
                " warning"
            );
            return;
        }
        colors.push({ color: newColor, available_amount: null });
        item.colors = colors;
        this.setState({ item });
    }

    deleteColor(color) {
        let { item } = this.state;
        let { colors } = item;

        colors.splice(
            colors.findIndex((c) => {
                return c.color.color === color;
            }),
            1
        );
        item.colors = colors;
        this.setState({ item });
    }

    getCropRes() {
        return null;
    }

    prepareMedias() {
        let { item } = this.state;
        let files = Array.from(this.fileInputRef.current.files).map((f) => {
            return {
                url: URL.createObjectURL(f),
                type: f.type.includes("image") ? "image" : "video",
                file: f,
            };
        });
        item.medias = item.medias ? item.medias : [];
        item.medias.push(...files);
        this.setState({ item });
        this.fileInputRef.current.value = null;
    }

    showMedia(media) {
        this.setState({ mediaToShow: media });
    }

    addSpece(e) {
        let { item } = this.state;
        let { speces } = item;
        if (!speces || speces.length < 1) {
            speces = this.state.speces;
            console.log(speces);
        }
        let newSpec = this.newSpeceInput.current.value;
        if (
            newSpec.toString() === "" ||
            Object.keys(speces).includes(newSpec)
        ) {
            this.newSpeceInput.current.className = "invalid";
            return;
        }

        speces[newSpec] = null;
        item.speces = speces;

        this.setState({ item, speces });
        this.newSpeceInput.current.value = "";
    }

    revertChanges() {
        this.setState({
            dialog: (
                <Dialog
                    message={
                        "آیا مطمئن هستید که میخواهید تمام تغیرات لغو شوند؟"
                    }
                    actions={[
                        {
                            text: "بله",
                            classes: "btn danger",
                            callback: (e) => {
                                window.location.reload(false);
                            },
                        },
                        {
                            text: "خیر",
                            classes: "btn confirm",
                            callback: (e) => {
                                this.setState({ dialog: null });
                            },
                        },
                    ]}
                ></Dialog>
            ),
        });
    }

    uploadFiles(files) {
        return new Promise((resolve, reject) => {
            if (files.length === 0) resolve([]);
            this.props.connection
                .upload(files, (results, reqs) => {
                    this.setState({
                        dialog: (
                            <Dialog
                                message={
                                    "در حال آپلود فایل ها لطفا منتظر بمانید ..."
                                }
                                progress={{
                                    current: results.length,
                                    total: reqs.length,
                                }}
                            ></Dialog>
                        ),
                    });
                })
                .then((results) => {
                    this.props.toast(
                        "آپلود",
                        "تمام فایل ها با موفقیت آپلود شدند",
                        " confirm"
                    );
                    resolve(results);
                })
                .catch((err) => {
                    this.props.toast(
                        "خطا در آپلود فایل ها",
                        `آپلود با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                            خطا:\n
                                            ${err.code}\n
                                            ${err.name}\n
                                            ${err.message}\n
                                            `,
                        " danger"
                    );
                    reject(err);
                });
        });
    }

    validate() {
        let errors = [];
        let inputs = this.containerRef.current.getElementsByTagName("input");
        let ob = {};
        inputs = Array.from(inputs)
            .filter((i) => {
                return i.type === "checkbox" || i.type === "text";
            })
            .map((i) => {
                return {
                    name: i.name,
                    group: i.getAttribute("group"),
                    value: i.type == "checkbox" ? i.checked : i.value,
                    element: i,
                };
            });
        inputs.forEach((input) => {
            let invalid = false;
            let { name, value, element, group } = input;
            value = toEnglishNumber(value);
            if (name == "name") {
                if (value === "") {
                    invalid = true;
                }
            } else if (name == "weight_per_unit") {
                if (value === "" || !parseFloat(value)) {
                    invalid = true;
                }
            } else if (name == "step") {
                if (value === "" || !parseFloat(value)) {
                    invalid = true;
                }
            } else if (name == "retail_min_amount") {
                if (value === "" || !parseFloat(value)) {
                    invalid = true;
                }
            } else if (name == "retail_price") {
                if (value === "" || !parseFloat(value)) {
                    invalid = true;
                }
            } else if (group == "color") {
                if (value === "" || !parseFloat(value)) {
                    invalid = true;
                }
            }

            if (invalid) {
                errors.push(input);
                element.className = element.className + " invalid";
            }
        });
        return { errors, inputs };
    }

    saveChanges() {
        if (this.validate().errors.length > 0) {
            this.props.toast(
                "خطا در ورودی ها ",
                "لطفا برای ورودی هایی که اطراف آنها قرمز شد است مقادیر صحیح وارد نمایید.",
                " danger"
            );
            return;
        }

        this.setState({
            dialog: (
                <Dialog
                    message={"آیا مطمئن هستید که میخواهید تغیرات اعمال شوند؟"}
                    actions={[
                        {
                            text: "بله",
                            classes: "btn confirm",
                            callback: (e) => {
                                //Save
                                this.setState({ dialog: null });

                                let { medias, id } = this.state.item;
                                this.uploadFiles(
                                    (medias || [])
                                        .filter((f) => {
                                            return f.file;
                                        })
                                        .map((f) => {
                                            return f.file;
                                        })
                                )
                                    .then((results) => {
                                        this.setState({ dialog: null });

                                        let newItem = Object.fromEntries(
                                            new FormData(this.formRef.current)
                                        );

                                        newItem.id = id;
                                        newItem.is_special_offer =
                                            newItem.is_special_offer === "on"
                                                ? true
                                                : false;
                                        newItem.has_wholesale =
                                            newItem.has_wholesale === "on"
                                                ? true
                                                : false;
                                        newItem.is_suggestion =
                                            newItem.is_suggestion === "on"
                                                ? true
                                                : false;

                                        newItem.medias =
                                            (medias || []).filter((f) => {
                                                return !f.file;
                                            }) || [];

                                        newItem.medias.push(
                                            ...results.map((r) => {
                                                return r;
                                            })
                                        );

                                        newItem.wholesale_min_amount =
                                            toEnglishNumber(
                                                newItem.wholesale_min_amount
                                            );
                                        newItem.wholesale_price =
                                            toEnglishNumber(
                                                newItem.wholesale_price
                                            );
                                        newItem.wholesale_discount =
                                            toEnglishNumber(
                                                newItem.wholesale_discount
                                            );
                                        newItem.special_offer_discount =
                                            toEnglishNumber(
                                                newItem.special_offer_discount
                                            );
                                        newItem.weight_per_unit =
                                            toEnglishNumber(
                                                newItem.weight_per_unit
                                            );
                                        newItem.step = toEnglishNumber(
                                            newItem.step
                                        );
                                        newItem.retail_min_amount =
                                            toEnglishNumber(
                                                newItem.retail_min_amount
                                            );
                                        newItem.retail_price = toEnglishNumber(
                                            newItem.retail_price
                                        );
                                        newItem.retail_discount =
                                            toEnglishNumber(
                                                newItem.retail_discount
                                            );

                                        if (!newItem.has_wholesale) {
                                            delete newItem.wholesale_min_amount;
                                            delete newItem.wholesale_price;
                                            delete newItem.wholesale_discount;
                                        }

                                        if (!newItem.is_special_offer) {
                                            delete newItem.special_offer_discount;
                                        }

                                        let colorsForm =
                                            Object.fromEntries(
                                                new FormData(
                                                    this.colorsFormRef.current
                                                )
                                            ) || {};

                                        let colors = Object.keys(
                                            colorsForm
                                        ).map((c) => {
                                            c = c.split(",");
                                            return { color: c[0], name: c[1] };
                                        });
                                        let amounts = Object.values(colorsForm);

                                        for (
                                            let i = 0;
                                            i < colors.length;
                                            i++
                                        ) {
                                            colors[i] = {
                                                color: colors[i],
                                                available_amount:
                                                    toEnglishNumber(amounts[i]),
                                            };
                                        }

                                        newItem.colors = colors;
                                        newItem.colors = newItem?.colors.map(
                                            (c) => {
                                                c.available_amount = parseFloat(
                                                    c.available_amount || 0
                                                );
                                                return c;
                                            }
                                        );

                                        newItem.categories =
                                            Object.keys(
                                                Object.fromEntries(
                                                    new FormData(
                                                        this.categoryFormRef.current
                                                    )
                                                )
                                            ) || [];

                                        let speces =
                                            Object.fromEntries(
                                                new FormData(
                                                    this.specesFormRef.current
                                                )
                                            ) || [];
                                        Object.keys(speces).map((s) => {
                                            if (speces[s] == "")
                                                delete speces[s];
                                        });

                                        newItem.speces = speces;

                                        if (
                                            this.props.router.location
                                                .pathname === "/items/new"
                                        ) {
                                            this.props.connection
                                                .addNewItem(newItem)
                                                .then((res) => {
                                                    this.props.toast(
                                                        "اضافه کردن",
                                                        "کالا با موفقیت اضافه شد \n کد کالا : " +
                                                            res.data.id,
                                                        " confirm"
                                                    );
                                                    this.props.router.navigate(
                                                        "/items/" + res.data.id
                                                    );
                                                })
                                                .catch((err) => {
                                                    this.props.toast(
                                                        "اضافه کردن",
                                                        " \nخطا در اضافه کردن کالا" +
                                                            "\n" +
                                                            err.data,
                                                        " danger"
                                                    );
                                                });
                                        } else {
                                            this.props.connection
                                                .updateItem(newItem)
                                                .then((res) => {
                                                    this.props.toast(
                                                        "ویرایش",
                                                        "کالا با موفقیت ویرایش شد" +
                                                            res.data.id,
                                                        " confirm"
                                                    );
                                                    this.props.router.navigate(
                                                        "/items/" + res.data.id
                                                    );
                                                })
                                                .catch((err) => {
                                                    this.props.toast(
                                                        "ویرایش",
                                                        " \nخطا در ویرایش کالا" +
                                                            "\n" +
                                                            err.data,
                                                        " danger"
                                                    );
                                                });
                                        }
                                    })
                                    .catch((err) => {
                                        this.props.toast(
                                            "خطا",
                                            "خطا در آپلود فایل ها لطفا مجددا امتحان کنید. ",
                                            " danger"
                                        );
                                    });
                            },
                        },
                        {
                            text: "خیر",
                            classes: "btn danger",
                            callback: (e) => {
                                this.setState({ dialog: null });
                            },
                        },
                    ]}
                ></Dialog>
            ),
        });
    }

    deleteItem() {
        this.setState({
            dialog: (
                <Dialog
                    message={
                        "آیا مطمئن هستید که میخواهید این کالا به طور کامل حذف شود؟"
                    }
                    actions={[
                        {
                            text: "بله",
                            classes: "btn danger",
                            callback: (e) => {
                                this.setState({ dialog: null });
                                this.props.connection
                                    .deleteItem(this.state.item.id)
                                    .then((res) => {
                                        this.props.toast(
                                            "حذف کالا",
                                            this.state.item.name +
                                                " با موفقیت حذف شد.",
                                            " confirm"
                                        );
                                        setTimeout(() => {
                                            this.props.router.navigate(
                                                "/items/"
                                            );
                                        }, 3000);
                                    })
                                    .catch((err) => {
                                        this.props.toast(
                                            "حذف کالا",
                                            "خطا در حذف کالا . کالا حذف نشد. " +
                                                err,
                                            " danger"
                                        );
                                    });
                            },
                        },
                        {
                            text: "خیر",
                            classes: "btn confirm",
                            callback: (e) => {
                                this.setState({ dialog: null });
                            },
                        },
                    ]}
                ></Dialog>
            ),
        });
    }

    deleteMedia(media) {
        let { item } = this.state;
        let { medias: medias } = item;
        medias.splice(
            medias.findIndex((m) => {
                return m == media;
            }),
            1
        );
        item.medias = medias;
        this.setState({ item });
    }

    maximizeImage(maxOrClose) {
        this.setState({ showMaximizedImage: maxOrClose });
    }

    render() {
        let { item, mediaToShow, categories, unit } = this.state;
        let specesDictionary = (item && item.speces) || this.state.speces;

        return (
            <Fragment>
                {this.state.dialog}

                <div className='ItemComponentContiner' ref={this.containerRef}>
                    <form ref={this.formRef} id='form'></form>
                    <div className='top'>
                        <div className='details'>
                            <div className='caption'>
                                <i className='fa-regular fa-file-lines primary'></i>
                                اطلاعات
                            </div>
                            <div className='generalInfo'>
                                <div className='caption'>
                                    <i className='fa-regular fa-file-lines primary'></i>
                                    اطلاعات کلی
                                </div>
                                <div className='id'>
                                    کد کالا
                                    <input
                                        className='item_id'
                                        form='form'
                                        name='id'
                                        defaultValue={item.id}
                                        type='text'
                                        disabled
                                        placeholder='کالای جدید'
                                    />
                                </div>
                                <div className='name'>
                                    نام کالا
                                    <input
                                        type='text'
                                        form='form'
                                        name='name'
                                        defaultValue={item.name}
                                    />
                                </div>
                                <div className='weight_per_unit flex flex-row gap-1 flex-nowrap'>
                                    وزن هر واحد
                                    <input
                                        name='weight_per_unit'
                                        type='number'
                                        className='w-[90px]'
                                        form='form'
                                        defaultValue={
                                            item.weight_per_unit &&
                                            item.weight_per_unit.toLocaleString()
                                        }
                                    />
                                    کیلو گرم
                                </div>
                                <div className='unit'>
                                    واحد
                                    <select
                                        name='unit'
                                        className='unitSelect'
                                        form='form'
                                        defaultValue={item.unit}
                                        onChange={(ev) => {
                                            this.setState({
                                                unit: ev.target.value,
                                            });
                                        }}
                                        ref={this.unitSelectRef}
                                    >
                                        <option value='متر'>متر</option>
                                        <option value='کیلوگرم'>کیلوگرم</option>
                                        <option value='عدد'>عدد</option>
                                    </select>
                                </div>
                                <div className='step'>
                                    گام
                                    <input
                                        name='step'
                                        type='number'
                                        form='form'
                                        defaultValue={
                                            item.step &&
                                            item.step.toLocaleString()
                                        }
                                    />
                                </div>
                                <div className='specialOffer'>
                                    <input
                                        name='is_suggestion'
                                        type='checkbox'
                                        form='form'
                                        className='enableSuggestion'
                                        defaultChecked={item.is_suggestion}
                                    />
                                    پیشنهاد ویژه
                                </div>
                            </div>

                            <div className='price'>
                                <div className='caption'>
                                    <i className='fa-regular fa-money-bill-1'></i>
                                    قیمت
                                </div>
                                <div className='retail'>
                                    <div className='caption'>خرده فروشی</div>

                                    <div className='retail_min_amount'>
                                        حداقل مقدار خرده فروشی
                                        <input
                                            name='retail_min_amount'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.retail_min_amount &&
                                                item.retail_min_amount.toLocaleString()
                                            }
                                        />
                                    </div>
                                    <div className='retail_price'>
                                        قیمت خرده فروشی
                                        <input
                                            name='retail_price'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.retail_price &&
                                                item.retail_price.toLocaleString()
                                            }
                                        />
                                    </div>
                                    <div className='retail_discount'>
                                        تخفیف خرده فروشی
                                        <input
                                            name='retail_discount'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.retail_discount &&
                                                item.retail_discount.toLocaleString()
                                            }
                                        />
                                    </div>
                                </div>
                                <div className='wholesale'>
                                    <div className='caption'>
                                        <input
                                            name='has_wholesale'
                                            type='checkbox'
                                            form='form'
                                            className='enableWholeSale'
                                            defaultChecked={item.has_wholesale}
                                        />
                                        عمده فروشی
                                    </div>

                                    <div className='wholesale_min_amount'>
                                        کمترین مفدار عمده فروشی
                                        <input
                                            name='wholesale_min_amount'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.wholesale_min_amount &&
                                                item.wholesale_min_amount.toLocaleString()
                                            }
                                        />
                                    </div>
                                    <div className='wholesale_price'>
                                        قیمت عمده فروشی
                                        <input
                                            name='wholesale_price'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.wholesale_price &&
                                                item.wholesale_price.toLocaleString()
                                            }
                                        />
                                    </div>
                                    <div className='wholesale_discount'>
                                        تخفیف عمده فروشی
                                        <input
                                            name='wholesale_discount'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.wholesale_discount &&
                                                item.wholesale_discount.toLocaleString()
                                            }
                                        />
                                    </div>
                                </div>

                                <div className='specialOffer'>
                                    <div className='caption'>
                                        <input
                                            name='is_special_offer'
                                            type='checkbox'
                                            form='form'
                                            className='enableSpecialOffer'
                                            defaultChecked={
                                                item.is_special_offer
                                            }
                                        />
                                        فروش ویژه
                                    </div>

                                    <div className='special_offer_discount'>
                                        تخفیف فروش ویژه
                                        <input
                                            name='special_offer_discount'
                                            type='number'
                                            form='form'
                                            defaultValue={
                                                item.special_offer_discount &&
                                                item.special_offer_discount.toLocaleString()
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='colors'>
                                <div className='caption'>
                                    <i className='fa-solid fa-palette'></i>
                                    رنگ های موجود
                                </div>
                                <div className='pickColor'>
                                    <input
                                        type='color'
                                        ref={this.colorPickerRef}
                                        defaultValue={"#953c3c"}
                                    />
                                    <input
                                        type='text'
                                        placeholder='نام رنگ'
                                        ref={this.newColorName}
                                    />
                                </div>

                                <button
                                    onClick={this.addColor}
                                    className='btn confirm'
                                >
                                    افزودن رنگ
                                    <i className='fa-solid fa-check'></i>
                                </button>
                                <form
                                    id='colorsForm'
                                    ref={this.colorsFormRef}
                                ></form>
                                {item.colors && item.colors.length > 0 && (
                                    <div className='chosenColors'>
                                        {item.colors.map((c) => {
                                            return (
                                                <div
                                                    className='chosenColor flex flex-row items-center'
                                                    key={c.color.color}
                                                >
                                                    <div
                                                        className='color'
                                                        style={{
                                                            backgroundColor:
                                                                c.color.color,
                                                        }}
                                                    >
                                                        <div
                                                            className='delete '
                                                            onClick={(e) =>
                                                                this.deleteColor(
                                                                    c.color
                                                                        .color
                                                                )
                                                            }
                                                        >
                                                            <i className='fa-regular fa-trash-can'></i>
                                                        </div>
                                                    </div>

                                                    <div
                                                        className='name'
                                                        style={{
                                                            color: c.color
                                                                .color,
                                                        }}
                                                    >
                                                        {c.color.name}
                                                    </div>

                                                    <input
                                                        className={`w-[100px] m-2`}
                                                        form='colorsForm'
                                                        name={`${c.color.color},${c.color.name}`}
                                                        type='number'
                                                        color={c.color.color}
                                                        group='color'
                                                        defaultValue={
                                                            c.available_amount ||
                                                            0
                                                        }
                                                        placeholder='مقدار موجودی'
                                                    />
                                                    <div className='amount'>
                                                        {unit}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            <div className='speces'>
                                <div className='caption'>
                                    <i className='fa-solid fa-table-list'></i>
                                    مشخصات
                                </div>

                                <form
                                    id='specesForm'
                                    ref={this.specesFormRef}
                                ></form>
                                <div className='flex flex-col w-full '>
                                    {Object.keys(specesDictionary).map(
                                        (sKey) => {
                                            return (
                                                <div
                                                    className={`max-w-full flex flex-row gap-2`}
                                                    value={sKey}
                                                    key={sKey}
                                                >
                                                    <div>
                                                        <button
                                                            className='btn empty btn-sm danger'
                                                            onClick={(e) => {
                                                                delete specesDictionary[
                                                                    sKey
                                                                ];
                                                                this.setState({
                                                                    speces: specesDictionary,
                                                                });
                                                            }}
                                                        >
                                                            <i className='ri-close-line '></i>
                                                        </button>
                                                    </div>
                                                    <div className='flex-1'>
                                                        {sKey}
                                                    </div>
                                                    <div>
                                                        <input
                                                            name={sKey}
                                                            group='speces'
                                                            type='text'
                                                            form='specesForm'
                                                            defaultValue={
                                                                item.speces &&
                                                                item.speces[
                                                                    sKey
                                                                ]
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        }
                                    )}

                                    <div
                                        className=' flex flex-row'
                                        key={"new-item"}
                                    >
                                        <div>
                                            <button
                                                className='btn empty'
                                                onClick={this.addSpece}
                                            >
                                                <i className='ri-add-line btn confirm'></i>
                                            </button>
                                        </div>
                                        <div>
                                            <input
                                                type='text'
                                                ref={this.newSpeceInput}
                                                required='required'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='categories'>
                                <div className='caption'>
                                    <i className='fa-solid fa-tags'></i>
                                    دسته بندی ها
                                </div>
                                <form
                                    id='category_form'
                                    ref={this.categoryFormRef}
                                >
                                    {categories &&
                                        categories.length > 0 &&
                                        categories.map((c) => {
                                            return (
                                                <div
                                                    className='category flex-1 flex-wrap min-w-[30%] flex flex-col'
                                                    key={c.name}
                                                >
                                                    <input
                                                        form='category_form'
                                                        type='checkbox'
                                                        name={c.name}
                                                        group='category'
                                                        defaultChecked={
                                                            item.categories &&
                                                            item.categories.find(
                                                                (cat) => {
                                                                    return (
                                                                        cat ===
                                                                        c.name
                                                                    );
                                                                }
                                                            )
                                                        }
                                                    />
                                                    <img
                                                        className='image'
                                                        src={c.image}
                                                    ></img>
                                                    <div className='name !text-sm'>
                                                        {c.name}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </form>
                            </div>
                        </div>
                        <div className='medias'>
                            <div className='caption'>
                                <i className='fa-solid fa-photo-film'></i>
                                رسانه ها
                            </div>

                            <div className='chooseFile'>
                                <input
                                    type='file'
                                    multiple
                                    ref={this.fileInputRef}
                                    onChange={this.prepareMedias}
                                />
                                <button className='chooseFile btn confirm'>
                                    انتخاب فایل
                                </button>
                            </div>

                            <div className='hint'>
                                <i className='ri-questionnaire-fill'></i>
                                تصویر با ابعاد 3:4 به نمایش در خواهد آمد بهتر از
                                ابعاد تصویر به همین صورت باشند.
                            </div>
                            <div className='maximize'>
                                <i
                                    className='fa-solid fa-maximize text info'
                                    onClick={(e) => this.maximizeImage(true)}
                                ></i>
                                {this.state.showMaximizedImage &&
                                    mediaToShow &&
                                    mediaToShow.url && (
                                        <div
                                            className='maximizedImage'
                                            onClick={(e) => {
                                                this.maximizeImage(false);
                                            }}
                                        >
                                            {mediaToShow.type == "image" ? (
                                                <img src={mediaToShow.url} />
                                            ) : (
                                                <video
                                                    src={mediaToShow.url}
                                                    controls
                                                ></video>
                                            )}
                                        </div>
                                    )}
                            </div>
                            <div className='cropTool'>
                                {mediaToShow && mediaToShow.url ? (
                                    mediaToShow.type == "image" ? (
                                        <img src={mediaToShow.url} />
                                    ) : (
                                        <video
                                            src={mediaToShow.url}
                                            controls
                                        ></video>
                                    )
                                ) : null}
                            </div>
                            {item.medias && item.medias.length > 0 && (
                                <div className='selectedMedias'>
                                    <div className='caption'>
                                        رسانه های انتخاب شده
                                    </div>

                                    {item.medias.map((m) => {
                                        return (
                                            <div
                                                className='selectedMedia'
                                                key={m.url || m.name}
                                            >
                                                <div
                                                    className='media'
                                                    onClick={(r) =>
                                                        this.showMedia(m)
                                                    }
                                                >
                                                    {m.type == "image" ? (
                                                        <img src={m.url} />
                                                    ) : (
                                                        <Fragment>
                                                            <video
                                                                src={m.url}
                                                            ></video>
                                                            <i className='fa-solid fa-play'></i>
                                                        </Fragment>
                                                    )}
                                                </div>
                                                <div
                                                    className='delete btn btn-sm danger'
                                                    onClick={(e) =>
                                                        this.deleteMedia(m)
                                                    }
                                                >
                                                    <i className='fa-regular fa-trash-can'></i>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='bottom'>
                        <div className='description'>
                            <div className='caption'>
                                <i className='fa-regular fa-message'></i>
                                توضیحات
                            </div>

                            <textarea
                                name='description'
                                defaultValue={item.description}
                                rows={10}
                                form='form'
                            ></textarea>
                        </div>
                    </div>

                    <div className='actions'>
                        <div
                            className='save btn confirm'
                            onClick={this.saveChanges}
                        >
                            ذخیره
                            <i className='fa-regular fa-floppy-disk'></i>
                        </div>
                        <div
                            className='cancel btn info'
                            onClick={this.revertChanges}
                        >
                            نادیده گرفتن تغیرات
                            <i className='fa-solid fa-xmark'></i>
                        </div>
                        <div
                            className='remove btn danger'
                            onClick={this.deleteItem}
                        >
                            حذف کالا<i className='fa-regular fa-trash-can'></i>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(Item);
